













































import { Component, Mixins } from 'vue-property-decorator'
import IconsMixin from '@/mixins/IconsMixin.vue'
import AuthMixin from '@/mixins/AuthMixin.vue'
import {
  Company,
  CompanyCollection
} from 'serverless-firestore'
import store, { Actions, Mutations } from '../../store'
import LoadingPage from '@/components/LoadingPage.vue'
import { Mutation } from 'vuex-class'
import UserCompaniesMixin from '../../mixins/UserCompaniesMixin.vue'
import { navigateToCompanyHome } from '../../router';

@Component({
  components: {
    LoadingPage
  }
})  export default class AdminDashboard extends Mixins(IconsMixin, AuthMixin, UserCompaniesMixin) {
  public loaded: boolean = false
  public companiesList: Company[] = []
  public selectedCompany: Company = {} as Company
  public companyNames: { company: Company, companyName: string }[] = []

  public async mounted() {
    if (!this.userClaim || !this.userClaim.admin) {
      const err = new Error('You do not have permissions to view that page')
      store.dispatch(Actions.SET_ERROR, [err, this.$router])
    }

    const companyCollection = new CompanyCollection(( await this.$firebase ).firestore())
    const companiesList = await companyCollection.list([['name', 'asc']])

    if (companiesList) {
      this.companiesList = companiesList

      this.companyNames = this.companiesList.map(company => (
        { company: company, companyName: company.displayName }
      ))
    }

    this.loaded = true
  }

  public async navigate() {
    const userCompanies = Object.values(this.userCompanies).reduce((acc, c) => {
      const adminCompany = c.adminCompanyId ? this.userCompanies[c.adminCompanyId] : null

      return (this.isInCompany(c) || this.isInCompany(adminCompany))
        ? { ...acc, [c.id]: c }
        : acc
    }, {} as { [companyId: string]: Company }[])

    store.commit(
      Mutations.UPDATE_COMPANIES,
      { companies: { ...userCompanies, [this.selectedCompany.id]: this.selectedCompany } }
    )
    const [currentCompany] = await store.dispatch(Actions.SET_USER_COMPANY, this.selectedCompany)
    navigateToCompanyHome(currentCompany)
  }

  private isInCompany(company: Company | null) {
    return company && (
      company.users.includes(this.user.uid)
      || company.admins.includes(this.user.uid)
    )
  }
}
